<template>
  <main class="app-main">
    <!--begin::App Content Header-->
    <div class="app-content-header">
      <!--begin::Container-->
      <div class="container-fluid">
        <!--begin::Row-->
        <div class="row">
          <div class="col-sm-6"><h3 class="mb-0">تعديل حي</h3></div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-end">
              <li class="breadcrumb-item"><router-link to="/">الرئيسية</router-link></li>
              <li class="breadcrumb-item"><router-link to="/neighborhoodview">الاحياء</router-link></li>
              <li class="breadcrumb-item active" aria-current="page">تعديل حي</li>
            </ol>
          </div>
        </div>
        <!--end::Row-->
      </div>
      <!--end::Container-->
    </div>
    <!--end::App Content Header-->
    <!--begin::App Content-->
    <div class="app-content">
      <!--begin::Container-->
      <div class="container-fluid">
        <!--begin::Row-->
        <div v-if="isLoading" class="text-center">
          <mainLoader />
        </div>
        <div v-else class="row justify-content-center align-content-center mb-4 mt-5">
          <div class="col-12 col-md-8">
            <h5 class="py-2 ms-2 text-brown">
              <i class="bi bi-pencil-square text-brown ps-2"></i>تعديل الحي
            </h5>
            <div class="card">
              <div class="text-center pt-3">
                <errorAlert v-if="regionError" :alertMessage= "message" />
              </div>
              <div v-if="successRegion" class="text-center pt-3">
                <successAlert :message="message" />
              </div>
              <div class="card-body">
                <form action="" @submit.prevent="neighborhoodFN">
                  <div class="row">
                    <div class="col">
                      <label for="">المنطقة</label>
                      <select class="form-select" v-model="region_id" @change="citiesList()">
                        <option value="">اختر المنطقة</option>
                        <option v-for="(row,index) in rows" :key="index" :value="row.id">
                          {{ row.name }}
                        </option>
                      </select>
                    </div>
                    <div class="col">
                      <label for="">المدينة</label>
                      <select class="form-select" v-model="cityId">
                        <option value="">اختر المدينة</option>
                        <option v-for="(city,index) in cities" :key="index" :value="city.id">
                          {{ city.name }}
                        </option>
                      </select>
                    </div>
                  </div>
                  <div class="row py-2">
                    <div class="col-12 col-sm-6">
                      <label for="">الاسم - عربي</label>
                      <input type="text" class="form-control" v-model="neighborhoodName">
                    </div>
                    <div class="col-12 col-sm-6">
                      <label for="">الاسم - انجليزي</label>
                      <input type="text" class="form-control" v-model="nameEn">
                    </div>
                  </div>
                  <div class="row py-2">
                    <div class="col">
                      <label for="">خط العرض (latitude)</label>
                      <input type="number" class="form-control" v-model="latitude" step="0.000001">
                    </div>
                  </div>
                  <div class="row py-2">
                    <div class="col">
                      <label for="">خط الطول (longitude)</label>
                      <input type="number" class="form-control" v-model="longitude" step="0.000001">
                    </div>
                  </div>
                  <div class="row py-2">
                    <div class="col">
                      <label for="">تحميل الصورة</label>
                      <input type="file" class="form-control" 
                      @change="onFileAdd($event.target.files)">
                    </div>
                  </div>
                  <div class="row">
                    <div class="col">
                      <img :src="BASE_URL+'uploads/'+coverimg" class="img-fluid" alt="">
                    </div>
                  </div>
                  <div class="row py-2">
                    <div class="col-12 col-sm-6">
                      <label for="">كود هيئة العقار:</label>
                      <input type="text" class="form-control" v-model="regaId" />
                    </div>
                    <div class="col-12 col-sm-6">
                      <label for="">الحاله</label>
                      <select class="form-control" v-model="status">
                        <option :value="true">نشط</option>
                        <option :value="false">غير نشط</option>
                      </select>
                    </div>
                  </div>
                  <div class="row py-2">
                    <div class="col text-center">
                      <loader v-if="loader" />
                      <button v-else type="submit" class="btn btn-success">إرسال</button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
        <!--end::Row-->
      </div>
      <!--end::Container-->
    </div>
    <!--end::App Content-->
  </main>
</template>
<script>
import { mapGetters } from 'vuex';
export default {
  name:'neighborhoodUpdate',
  data(){
    return {
      neighborhoodID: this.$route.params.id,
      regionError: false,
      message: '',
      neighborhoodName: "",
      nameEn: "",
      isLoading: false,
      status: true,
      successRegion: false,
      longitude: "",
      latitude: "",
      rows:[],
      region_id: '',
      cities: [],
      cityId: '',
      coverimg: "",
      loader: false,
      regaId: null,
    }
  },
  computed:{
    ...mapGetters(['BASE_URL'])
  },
  methods:{
    getData() {
      this.regionError = false;
      this.isLoading = true;
      this.$http.get(`/api/admin/neighborhoods/retrieve/${this.neighborhoodID}`).then(res => {
        this.isLoading = false;
        this.rows = res.data.regions;
        this.cities = res.data.cities;
        this.cityId = res.data.neighborhood.cityId;
        this.region_id = res.data.neighborhood.regionId;
        this.neighborhoodName = res.data.neighborhood.name;
        this.nameEn = res.data.neighborhood.nameEn;
        this.longitude = res.data.neighborhood.longitude;
        this.latitude = res.data.neighborhood.latitude;
        this.coverimg = res.data.neighborhood.cover;
        this.status = res.data.neighborhood.isActive;
        this.regaId = res.data.neighborhood.regaId;
      }).catch(err => {
        this.message = this.$globalError(err);
        this.regionError = true;
        this.isLoading = false;
        window.scroll(0,0);
      })
    },
    neighborhoodFN(){
      this.loader = true;
      this.regionError = false;
      this.successRegion = false;
      this.message = "";
      if(this.region_id == ''){
        this.message = 'يجب اختيار المنطقة';
        this.regionError = true;
        window.scroll(0,0);
        return false;
      }
      if(this.cityId == ''){
        this.message = 'يجب اختيار المدينة';
        this.regionError = true;
        window.scroll(0,0);
        return false;
      }
      if(this.neighborhoodName == ""){
        this.message = 'يجب ادخل اسم الحي';
        this.regionError = true;
        window.scroll(0,0);
        return false;
      }
      if(this.nameEn == ""){
        this.message = 'يجب ادخل اسم الحي باللغة الانجليزية';
        this.regionError = true;
        window.scroll(0,0);
        return false;
      }
      const formData = new FormData();
      formData.append('regionId',this.region_id);
      formData.append('cityId',this.cityId);
      formData.append('name',this.neighborhoodName);
      formData.append('nameEn',this.nameEn);
      formData.append('latitude',this.latitude);
      formData.append('longitude',this.longitude);
      formData.append('cover',this.coverimg);
      formData.append('isActive',this.status);
      if(this.regaId)
        formData.append('regaId',this.regaId);

      this.$http.put(`/api/admin/neighborhoods/update/${this.neighborhoodID}`,formData).then(res => {
        this.loader = false;
        this.message = 'تم التعديل بنجاح';
        this.successRegion = true;
        window.scroll(0,0);
      }).catch(err => {
        this.message = this.$globalError(err);
        this.regionError = true;
        this.loader = false;
        window.scroll(0,0);
      })
    },
    citiesList() {
      this.cityId = '';
      if(this.region_id == '')
        return;
      this.hasError = false;
      this.isLoading = true;
      this.$http.get(`/api/admin/cities/list?regionId=${this.region_id}&all=1`).then(res => {
        this.isLoading = false;
        this.cities = res.data.cities;
      }).catch(err => {
        this.message = this.$globalError(err);
        this.hasError = true;
        this.isLoading = false;
        window.scroll(0,0);
      })
    },
    onFileAdd(files){
      this.coverimg = files[0];
    }
  },
  created() {
    this.getData();
  }
}
</script>